export const toPlainQuote = (value: string): string => {
  const trimmed = value.trim();
  if (!trimmed) return "";
  if (!trimmed.includes("<")) return trimmed;
  if (typeof DOMParser === "undefined") {
    return trimmed.replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim();
  }
  const doc = new DOMParser().parseFromString(trimmed, "text/html");
  return (doc.body.textContent || "").replace(/\s+/g, " ").trim();
};

export const getCommentThreadId = (comment: {
  threadId?: string;
  clientCommentId?: string;
}): string | null => {
  if (comment.threadId) return comment.threadId;
  if (comment.clientCommentId?.startsWith("thread-")) {
    return comment.clientCommentId;
  }
  return null;
};

export const getCommentQuote = (comment: { quotedText?: string }): string =>
  comment.quotedText?.trim() || "";
